import {makeAutoObservable} from 'mobx';

import type {MultiSelectChangeEventAction} from '../../../uikit/Select/types';
import type {StringKeysOnly} from '../../../utils/utility-types';
import type {DataFilterState} from './DataFilterState';

export class DataFilterFieldInput<Data = any> {
  selected: Set<DataFilterFieldInput.Option> = new Set();

  constructor(
    public key: StringKeysOnly<Data>,
    public label: string,
    public placeholder: string = '',
    public options: DataFilterFieldInput.Option[] = [],
    // public type: DataFilterFieldInput.Type,
  ) {
    makeAutoObservable(this, undefined, {
      autoBind: true,
    });
  }

  get isClear() {
    return this.selected.size === 0;
  }

  get renderOptions() {
    return this.options.map(option => ({label: option, value: option}));
  }

  get renderSelected() {
    return Array.from(this.selected).map(option => ({
      label: option,
      value: option,
    }));
  }

  onChange({payload}: MultiSelectChangeEventAction<string>) {
    if (payload) {
      this.setSelected(payload.map(item => item.value));
    }
  }

  setSelected(selected: DataFilterFieldInput.Option[]) {
    this.selected = new Set(selected);
  }

  toState(): DataFilterState.Field {
    return {key: this.key, values: this.selected};
  }
}

export namespace DataFilterFieldInput {
  // export type Type = 'text' | 'date' | 'select';
  export type Option = string;
}
